import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../../service/urlcanonica.service';
import { Subscription } from 'rxjs';
import { filter, finalize } from 'rxjs/operators';
import { LicitacionService } from '../../../../service/licitacion.service';


@Component({
  selector: 'app-consultas-reportes',
  templateUrl: './consultas-reportes.component.html',
  styleUrls: ['./consultas-reportes.component.css']
})
export class ConsultasReportesComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	toggle:boolean = true;
	toggle2:boolean = true;
	activo: any;
	////////
	editar = false;
	resultadoBusqueda = false;
	consultaProveedoresLicitantes = false;
	consultaLicitantes = false;
	usuario = false;
	usuarioEditar = false;
	success= false;
	fail = false;
	status: boolean = true;
	///////

	constructor( 
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private _licitacionservice: LicitacionService,
		private router: Router,
		private _urlcanonicaservice: UrlcanonicaService
		) {
			if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('user') == null || sessionStorage.getItem('user') == 'null')){
				this.router.navigate(['/licitaciones/administrador/login']);
			}
			this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.RouteText = event;
				this.getSEO(event.url)
			});
		}


	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.image;
		
			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}
  
	ngOnInit(): void {
	}

	//////////
	openOne(){
		this.consultaProveedoresLicitantes = true;
	}

	openTwo(){
		this.consultaLicitantes = true;
	}
	cancel() {
		this.consultaProveedoresLicitantes = false;
		this.consultaLicitantes = false;
		this.editar = false;
		this.resultadoBusqueda = false;
	}
	cancelEditar() {
		this.usuarioEditar = false;
		this.consultaLicitantes = true;    
	}
	busqueda(){
		this.resultadoBusqueda = true;
	}
	closeok() {
		this.success= false;
		this.fail = false;
		this.consultaProveedoresLicitantes = false;
		this.consultaLicitantes = false;
		this.usuarioEditar = false;
	}
	//--//
	change() {
		this.editar = true;
		this.consultaLicitantes = false;
	}
	confirmacion() {
		this.consultaProveedoresLicitantes = true;
		this.consultaLicitantes = true;
		this.success= true;
		this.editar = false;
	}
	confirmacionUsuario() {
		this.success= true;
	}
	closefail() {
		this.success= false;
		this.editar = true;
	}
	user() {
		this.usuario = true;
		this.status = !this.status; 
	}
	userEdit() {
		this.usuarioEditar = true;
	}
	////////////

}